export default __webpack_public_path__ + "static/media/My project (83) 1 (1).f5b86b2c.png";